import ApiService from '../services/ApiService';
import FileService from "../services/FileService";
import camelcaseKeys from "camelcase-keys";

export default class OrganizerRepository {
    constructor() {
        this.apiService = new ApiService();
        this.fileService = new FileService();
    }

    getOrganizer(id) {
        return new Promise((resolve, reject) => {
            this.apiService.get(`organizers/${id}`)
              .then(response => resolve(this.transformResponseToOrganizer(response)))
              .catch(error => reject(error))
        });
    }

    getOrganizers(sort = '') {
        return new Promise((resolve, reject) => {
            this.apiService
                .get(`organizers?sort=${sort}`)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    deleteOrganizer(id) {
        return new Promise((resolve, reject) => {
            this.apiService.delete(`organizers/${id}`)
              .then(response => resolve(response))
              .catch(error => reject(error));
        });
    }

    updateOrganizer(id, data) {
        return new Promise((resolve, reject) => {
            this.apiService.post(`organizers/${id}`, this.transformDataForRequest(data, 'PUT'))
              .then(response => resolve(response))
              .catch(error => reject(error));
        });
    }

    transformDataForRequest(data, method = null) {
        if (data.privacy_policy) {
            data.privacy_policy = this.fileService.convertBase64ToFIle(
              data.privacy_policy,
              data.privacy_policy_name
            );
        }

        return this.apiService.convertDataToFormData(data, method);
    }

    transformResponseToOrganizer(organizer) {
        organizer = camelcaseKeys(organizer);

        return organizer;
    }
}
